import { Box, Button, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import Al_Khan_Sharjah_lagoon_aerial_view from "../../assets/area/Al_Khan_Sharjah_lagoon_aerial_view.jpg";
import Al_Majaz_Sharjah_waterfront_skyline from "../../assets/area/Al_Majaz_Sharjah_waterfront_skyline.webp";
import Al_Mamsha_Sharjah_modern_apartments from "../../assets/area/Al_Mamsha_Sharjah_modern_apartments.jpg";
import Aljada_Sharjah_master_plan_aerial from "../../assets/area/Aljada_Sharjah_master_plan_aerial.jpg";
import buyers1 from "../../assets/dubai-buy.jpg";
import { PremiumBuyerRightCollage } from "./PremiumBuyerRightCollage";

export default function ForBuyers() {
  const [index, setIndex] = useState(0);
  const SWIPE_THRESHOLD = 80;

  const slides = [
    {
      image: buyers1,
      eyebrow: "UAE",
      title: "Luxury Investment Properties",
    },
    {
      image: Al_Majaz_Sharjah_waterfront_skyline,
      eyebrow: "Sharjah • Al Majaz",
      title: "Iconic Waterfront Living",
    },
    {
      image: Al_Khan_Sharjah_lagoon_aerial_view,
      eyebrow: "Sharjah • Al Khan",
      title: "Lagoon-Facing Residences",
    },
    {
      image: Aljada_Sharjah_master_plan_aerial,
      eyebrow: "Sharjah • Aljada",
      title: "Master-Planned Urban Living",
    },
    {
      image: Al_Mamsha_Sharjah_modern_apartments,
      eyebrow: "Sharjah • Al Mamsha",
      title: "Contemporary Walkable Communities",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 3000); // 3 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    // <Box
    //   sx={{
    //     position: "relative",
    //     backgroundColor: "var(--color-primary-dark)",
    //     py: { xs: 8, md: 18 },
    //     overflow: "hidden",
    //   }}
    // >
    <Box
      sx={{
        position: "relative",
        backgroundColor: "var(--color-bg)",
        py: { xs: 4, md: 4 },
        overflow: "hidden",
      }}
    >
      {/* TOP GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />

      <Container maxWidth="xl">
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.1fr 0.9fr" },
            gap: { xs: 5, md: 14 },
            alignItems: "center",
          }}
        >
          {/* LEFT CONTENT */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <Typography
              sx={{
                color: "var(--color-gold)",
                letterSpacing: "0.28em",
                fontSize: 12,
                mb: 3,
                fontWeight: 500,
              }}
            >
              FOR BUYERS
            </Typography>

            <Typography
              sx={{
                // color: "var(--color-white)",
                color: "var(--color-text-primary)",
                fontSize: { xs: "1.9rem", sm: "2.2rem", md: "3rem" },
                fontWeight: 600,
                lineHeight: 1.15,
                mb: 4,
                maxWidth: 520,
              }}
            >
              Want To{" "}
              <Box component="span" sx={{ color: "var(--color-gold)" }}>
                Buy
              </Box>{" "}
              a <br />
              Luxury Property?
            </Typography>

            <Typography
              sx={{
                // color: "rgba(255,255,255,0.8)",
                color: "var(--color-text-muted)",

                fontSize: { xs: 14, md: 15 },
                lineHeight: { xs: 1.8, md: 2 },

                maxWidth: 520,
                mb: 6,
              }}
            >
              Discover a handpicked portfolio of exceptional properties designed
              for refined lifestyles and intelligent investments. From iconic
              residences to high-yield opportunities, our advisors deliver
              discreet, strategic guidance — ensuring clarity, confidence, and
              results at every stage of your buying journey.
            </Typography>

            {/* CTA GROUP */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "flex-start", sm: "center" },
                gap: { xs: 2.5, sm: 4 },
              }}
            >
              <Button
                sx={{
                  height: 54,
                  px: 5,
                  borderRadius: "40px",
                  background: "var(--color-gold)",
                  color: "var(--color-primary-dark)",
                  border: "none",
                  textTransform: "uppercase",
                  fontSize: 13,
                  letterSpacing: "0.22em",
                  fontWeight: 600,
                  transition: "all 0.35s ease",
                  boxShadow: "0 18px 40px rgba(0,0,0,0.25)",

                  "&:hover": {
                    background: "var(--color-gold)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 28px 65px rgba(0,0,0,0.35)",
                  },

                  "&:active": {
                    transform: "translateY(0)",
                    boxShadow: "0 14px 28px rgba(0,0,0,0.25)",
                  },
                }}
              >
                Contact Our Experts
              </Button>

              <Typography
                sx={{
                  // color: "rgba(255,255,255,0.6)",
                  color: "var(--color-text-muted)",

                  fontSize: 12,
                  letterSpacing: "0.12em",
                }}
              >
                Trusted • Discreet • Strategic
              </Typography>
            </Box>
          </motion.div>

          {/* RIGHT IMAGE FEATURE */}
          <PremiumBuyerRightCollage />
          {/* <motion.div
            initial={{ opacity: 0, scale: 0.92 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.9, delay: 0.15 }}
            viewport={{ once: true }}
          >
            <Box
              sx={{
                position: "relative",
                borderRadius: "36px",
                overflow: "hidden",
                backgroundColor: "var(--color-white)",
                boxShadow: "0 40px 80px rgba(0,0,0,0.25)",
              }}
            >
              <motion.img
                key={index}
                src={slides[index].image}
                alt="Luxury Real Estate"
                drag="x"
                dragConstraints={{ left: 0, right: 0 }}
                onDragEnd={(e, info) => {
                  if (info.offset.x < -SWIPE_THRESHOLD) {
                    setIndex((prev) => (prev + 1) % slides.length);
                  } else if (info.offset.x > SWIPE_THRESHOLD) {
                    setIndex((prev) =>
                      prev === 0 ? slides.length - 1 : prev - 1
                    );
                  }
                }}
                initial={{ opacity: 0, scale: 1.08 }}
                animate={{ opacity: 1, scale: 1.05 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  height: window.innerWidth < 600 ? 260 : 520,
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(180deg, rgba(255,255,255,0.05), rgba(0,0,0,0.35))",
                  pointerEvents: "none",
                }}
              />

              <Box
                sx={{
                  position: "absolute",
                  bottom: 28,
                  left: 28,
                  color: "var(--color-white)",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 13,
                    letterSpacing: "0.18em",
                    color: "var(--color-gold)",
                    mb: 0.5,
                  }}
                >
                  {slides[index].eyebrow}
                </Typography>
                <Typography sx={{ fontSize: 15, fontWeight: 500 }}>
                  {slides[index].title}
                </Typography>
              </Box>

              <Box
                sx={{
                  position: "absolute",
                  bottom: 24,
                  right: 28,
                  display: "flex",
                  gap: 1.2,
                }}
              >
                {slides?.map((_, i) => (
                  <Box
                    key={i}
                    onClick={() => setIndex(i)}
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      cursor: "pointer",
                      background:
                        i === index
                          ? "var(--color-gold)"
                          : "rgba(255,255,255,0.4)",
                      transition: "all 0.3s ease",
                    }}
                  />
                ))}
              </Box>
            </Box>
          </motion.div> */}
        </Box>
      </Container>

      {/* BOTTOM GOLD LINE */}
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: "5%",
          right: "5%",
          height: "1px",
          background:
            "linear-gradient(90deg, transparent, var(--color-gold), transparent)",
          opacity: 0.6,
        }}
      />
    </Box>
  );
}
